const inAppMessaging = () => {
  return {
    setMessagesDisplaySuppressed: async (_: boolean): Promise<void> => {},
  };
};
export default inAppMessaging;
